import { render, staticRenderFns } from "./organization.vue?vue&type=template&id=66d8ccd1"
import script from "./organization.ts?vue&type=script&lang=js&external"
export * from "./organization.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports